import moment from 'moment'

export const data = () => ({
  isDebug: true,
  loading: false,
  actionItemID: 0,
  selectedNote: null,
  actionItemNoteID: 0,
  toggle: false,
  formatDateFn: function(value) {
    return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
  },

  filters: {
    show: false
  },

  pagination: {
    perPage: 10
  },

  region: {},

  rows: [],

  columns: [
    {
      field: 'note',
      label: 'Note',
      aria: 'Note',
      width: '55%',
      sortable: true,
      searchable: true
    },
    {
      field: 'author',
      label: 'Author',
      aria: 'Author',
      width: '30%',
      sortable: true,
      searchable: true
    },
    {
      field: 'createdDate',
      date: true,
      label: 'Created',
      aria: 'Created',
      width: '15%',
      sortable: true,
      searchable: true
    }
  ],

  styles: {
    formRow: {
      padding: '10px',
      whiteSpace: 'nowrap'
    },
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
